<template>
    <div>
        <div class="configuration-controls">
            <div class="individual-control journey-selector">
                <label>{{resource('JourneyBuilder_Shared_Journey')}}</label>
                <journey-dropdown v-model="journeyIdModel" />
            </div>

            <div class="individual-control period-selector">
                <label>{{resource('JourneyBuilder_Sankey_Period_Label')}}</label>
                <period-picker />
            </div>

            <div class="individual-control inflow-period-selector">
                <label>{{resource('JourneyBuilder_Sankey_InflowPeriod_Label')}}</label>
                <inflow-period-picker />
            </div>

            <div class="individual-control product-selector">
                <label>{{resource('JourneyBuilder_Sankey_ProductIds_Label')}}</label>
                <products-selector />
            </div>

            <div class="individual-control highlight-mode-selector">
                <label>{{resource('JourneyBuilder_Sankey_HighlightMode_Label')}}</label>
                <highlight-mode-selector />
            </div>

            <div class="individual-control tag-route-type-selector">
                <label>{{resource('JourneyBuilder_Sankey_GoalRouteToggle_Label')}}</label>
                <tag-route-type-selector />
            </div>

            <div class="sankey-explanation">
                <label>{{resource('JourneyBuilder_Sankey_TouchpointSelection_Explanation')}}</label>
            </div>
        </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import resourceMixin from "@core/Util/Mixins/resources";

import SankeyV2, { PeriodPicker, HighlightModeSelector, TagRouteTypeSelector, ProductsSelector, InflowPeriodPicker } from "@modules/JourneyBuilder/Components/Charts/SankeyV2";
import BootstrapBox from "@core/Components/Util/BootstrapBox";
import JourneyDropdown from "@modules/JourneyBuilder/Components/Elements/JourneyDropdown";
import LoadingBox from "@core/Components/Util/LoadingBox";

const { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('journeyBuilder/reporting');

export default {
    name: 'journey-statistics-configuration',
    
    components: {
        SankeyV2,
        PeriodPicker,
        BootstrapBox,
        JourneyDropdown,
        HighlightModeSelector,
        TagRouteTypeSelector,
        ProductsSelector,
        InflowPeriodPicker,
        LoadingBox
    },
    
    mixins: [resourceMixin],

    computed: {
        ...mapState(['journeyId']),
        journeyIdModel: {
            get(){ 
                return this.journeyId; 
            },
            set(value){ 
                this.setJourneyId(value); 
            }
        },
    },

    methods: {
        ...mapMutations(['setJourneyId'])
    },
}
</script>

<style scoped>
    .highlight-mode-selector { grid-area: highlight-mode-selector; }
    .journey-selector { grid-area: journey-selector; }
    .period-selector { grid-area: period-selector; }
    .inflow-period-selector { grid-area: inflow-period-selector; }
    .tag-route-type-selector { grid-area: tag-route-type-selector; }
    .product-selector { grid-area: product-selector; }
    .sankey-explanation { grid-area: sankey-explanation; }

    .individual-control {
        display: grid;
        grid-template: auto / 70px auto;
    }
    
    .configuration-controls {
        display: grid;
        
        grid-template-columns: 0.25fr 0.25fr 0.25fr auto;
        grid-row-gap: 5px;
        grid-column-gap: 30px;
        grid-template-areas: 
            "journey-selector . . ."
            "period-selector inflow-period-selector product-selector ."
            "highlight-mode-selector highlight-mode-selector highlight-mode-selector highlight-mode-selector"
            "tag-route-type-selector . . ."
            "sankey-explanation sankey-explanation sankey-explanation sankey-explanation";
    }
</style>